"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const error_1 = require("../error");
/**
 * Exception thrown when a security error occurs at runtime.
 *
 * @author Eric MORAND <eric.morand@gmail.com>
 */
class TwingSandboxSecurityError extends error_1.TwingError {
}
exports.TwingSandboxSecurityError = TwingSandboxSecurityError;
